import React, { useEffect, useState } from 'react';
import './FetchingIndicator.css';

// Hard cap on how long the floater stays visible. Even if a request is
// genuinely still pending (sleeping backend, slow network), users found a
// long-running spinner more alarming than helpful — they assume the app is
// hung. After 5s we hide the indicator; any data still pending will populate
// silently when it arrives, and the cached dashboard remains fully usable.
const MAX_VISIBLE_MS = 5000;

const FetchingIndicator = ({ show, label = 'Fetching latest data…' }) => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!show) {
      setHidden(false);
      return undefined;
    }
    const t = setTimeout(() => setHidden(true), MAX_VISIBLE_MS);
    return () => clearTimeout(t);
  }, [show]);

  if (!show || hidden) return null;
  return (
    <div className="fi-floater" role="status" aria-live="polite">
      <span className="fi-spinner" />
      <span className="fi-label">{label}</span>
    </div>
  );
};

export default FetchingIndicator;
